import { render, staticRenderFns } from "./GlossaryWidget.vue?vue&type=template&id=1b2fae5f&scoped=true"
import script from "./GlossaryWidget.vue?vue&type=script&lang=js"
export * from "./GlossaryWidget.vue?vue&type=script&lang=js"
import style0 from "./GlossaryWidget.vue?vue&type=style&index=0&id=1b2fae5f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2fae5f",
  null
  
)

export default component.exports